import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { SlidersHorizontal, X } from "lucide-react";
import { getAnalyticsStatus, getConsent, setConsent } from "../lib/analytics";
import "./AnalyticsConsent.css";

export { openAnalyticsPreferences } from "../lib/analytics";

export default function AnalyticsConsent() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(() => {
    const status = getAnalyticsStatus();
    return status.bannerEnabled && !getConsent() && (status.gaConfigured || status.dashboardConfigured);
  });
  const heading = useRef(null);
  const returnFocus = useRef(null);
  useEffect(() => {
    const open = () => {
      returnFocus.current = document.activeElement;
      setVisible(true);
      window.setTimeout(() => heading.current?.focus(), 50);
    };
    const syncChoice = () => {
      if (getConsent()) setVisible(false);
    };
    window.addEventListener("karalewich:open-analytics-preferences", open);
    window.addEventListener("karalewich:analytics-consent", syncChoice);
    return () => {
      window.removeEventListener("karalewich:open-analytics-preferences", open);
      window.removeEventListener("karalewich:analytics-consent", syncChoice);
    };
  }, []);
  const choose = (value) => {
    setConsent(value);
    setVisible(false);
    returnFocus.current?.focus?.();
  };
  const cookieless = getAnalyticsStatus().mode === "cookieless";
  if (!visible || /^\/(admin|login)(\/|$)/.test(pathname)) return null;
  return (
    <aside
      className="k-consent"
      aria-labelledby="k-consent-title"
      role="region"
    >
      <div className="k-consent-top">
        <span className="k-consent-icon">
          <SlidersHorizontal size={18} />
        </span>
        <h2 id="k-consent-title" ref={heading} tabIndex={-1}>
          {cookieless ? "Your analytics preferences." : "A little insight. Your choice."}
        </h2>
        <button
          className="k-consent-close"
          onClick={() => choose("denied")}
          aria-label="Close and use essential storage only"
        >
          <X size={16} />
        </button>
      </div>
      <p>
        {cookieless ? "First-party analytics use temporary in-memory visit IDs, not tracking cookies or persistent visitor identifiers. Form contents are never included. You can opt out below." : "Optional analytics help us understand which ideas are useful. Your messages and demo questions stay out of analytics."}
      </p>
      <div className="k-consent-actions">
        <button onClick={() => choose("denied")}>{cookieless ? "Disable analytics" : "Essential only"}</button>
        <button onClick={() => choose("granted")}>{cookieless ? "Allow cookieless analytics" : "Allow analytics"}</button>
      </div>
      <p className="k-consent-foot">
        Change this anytime in the footer.{" "}
        <Link to="/privacy" onClick={() => setVisible(false)}>
          Privacy details
        </Link>
      </p>
    </aside>
  );
}
